<div class="main-container">
  <div class="header mt-3">
    <div class="warnig-with-icon">
      <img src="\assets\icons\warning.png" />
      <label class="warning">{{ data?.title }}</label>
    </div>
    <div class="close-icon">
      <img src="\assets\icons\close.png" (click)="onCancel()" />
    </div>
  </div>
  <div class="line"></div>

  <div class="body-text">
    <label> {{ data?.message }} </label>
    <!-- Add more cases if needed -->
  </div>

  <div class="footer">
    <button class="no" (click)="onCancel()">No</button>
    <button class="yes" (click)="onConfirm()">Yes</button>
  </div>
</div>
